/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { Col, Divider, Drawer, Form, Input, Row } from 'antd';

import RemovedTasksReportForm from './RemovedTasksReportForm';
import TaskReportForm from './TaskReportForm';

function ExportDataDrawer({ isOpen, setIsOpen }) {
  const [loading] = useState(false);
  const [form] = Form.useForm();
  const userData = JSON.parse(localStorage.getItem('conecta__userData') || '{}');
  const email = userData.email || '';

  return (
    <Drawer
      title="Exportação de Dados"
      placement="right"
      onClose={() => setIsOpen(false)}
      open={isOpen}
      width="40%"
    >
      <Row gutter={[24]}>
        <Col span={24}>
          <Form
            form={form}
            layout="vertical"
            initialValues={{ email }}
            style={{ marginBottom: 24 }}
          >
            <Form.Item
              label="E-mail para envio do relatório"
              name="email"
              rules={[
                { required: true, message: 'Campo obrigatório!' },
                { type: 'email', message: 'E-mail inválido!' },
              ]}
            >
              <Input value={email} disabled />
            </Form.Item>
          </Form>
        </Col>

        {/* Relatório de Treinamentos */}
        <Col span={24}>
          <Divider className="configuration-divider" orientation="left">
            Relatório de Treinamentos
          </Divider>
          <TaskReportForm loading={loading} userEmail={email} />
        </Col>

        {/* Relatório de Treinamentos Removidos */}
        <Col span={24}>
          <Divider className="configuration-divider" orientation="left">
            Relatório de Treinamentos Removidos
          </Divider>
          <RemovedTasksReportForm loading={loading} userEmail={email} />
        </Col>
      </Row>
    </Drawer>
  );
}

export default ExportDataDrawer;
